import '../styles/fitp.css';
import curt from 'url:../assets/lordge-curtains.png';

export function FITP () {
    return <div className="fitp-page">
        <img src={curt} className='fitp-cL' />
        <img src={curt} className='fitp-cR' />
        <div className='fitp-f' />
    </div>
}